import { RouterProvider } from "react-router-dom";
import "@github/markdown-toolbar-element";
import "../branchAndBrandSpecific/styles/main.scss";
import { router } from "./../branchAndBrandSpecific/Routes";
import { useEffect } from "react";
import brand from "../branchAndBrandSpecific/utils/brandVariables/brandVariables";

function App(): JSX.Element {
  //pushing to main- > should appear in LENOVO_IMAGINE_2023
  //pushing to main- > should appear in LENOVO_IMAGINE_23 - new branch

  useEffect(() => {
    let link: any = document.querySelector("link[rel~='icon']");

    if (document.title.length === 0) {
      document.title = brand.siteTitle;
    }

    if (!link) {
      link = document.createElement("link");
      if (link) {
        link.rel = "icon";
        document.head.appendChild(link);
        link.href = brand.siteIcon;
      }
    }

    console.log(window.location.pathname);

    if (window.location.pathname.includes("daily-tasks-leaderboard-full")) {
      if (!document.body.classList.contains("landing-bg-legion")) {
        document.body.classList.add("landing-bg-legion");
      }
    }
  }, []);
  // return <RouterProvider router={router} />;
  return (
    <div className="thankyou-message">
      <p>Thank you for participating in Dreamhack Winter 2023!</p>
    </div>
  );
}

export default App;
